import axios from 'axios';
import {useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import LockIcon from '@mui/icons-material/Lock';
import PushPinIcon from '@mui/icons-material/PushPin';

import LoadListExport from './LoadListExport';
import LoadListModeLockLoadsLookup from './LoadListModeLockLoadsLookup';
import LoadListModePinLoadsLookup from './LoadListModePinLoadsLookup';

import { useSessionContext } from '../../../contexts/SessionContext';


export default function LoadListMode(props) {
    //console.debug("RTS Break LoadListMode");

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("xs"));

    const {user, sessionCustomer, userAuthToken, apiRoot} = useSessionContext();

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorBody, setErrorBody] = useState("");
    const [errorTitle, setErrorTitle] = useState("Validation Error");
    const [showExportModal, setShowExportModal] = useState(false);
    const [showLoadLocksModal, setShowLoadLocksModal] = useState(false);    
    const [showLoadPinsModal, setShowLoadPinsModal] = useState(false);    
    const [showLoadPinsIcon, setShowLoadPinsIcon] = useState(true);
    const [showLoadLocksIcon, setShowLoadLocksIcon] = useState(true);

    useEffect(() => {
            if(props.locksIcon != undefined){
                setShowLoadLocksIcon(props.locksIcon);
            }

            if(props.pinsIcon != undefined){
                setShowLoadPinsIcon(props.pinsIcon);
            }
    }, [props]); 





    function showMap(e){
        if(props.mode !== 1){
            props.modeFx(1);
        }
    }


    function showList(e){
        if(props.mode !== 0){
            props.modeFx(0);
        }
    }


    function clickLock(e){
        setShowLoadLocksModal(true);
    }


    function clickDownload(e){
        setShowExportModal(true);
    }


    function clickPin(e){
        setShowLoadPinsModal(true);
    }; 

    
    
    function addLoadLocks(args){
        let apiObj = [];
        args.forEach((item, idx) => {
            apiObj[idx] = {AppUser:user, Customer:sessionCustomer.customer, Load:item, Action:1};
        });

        if(apiObj.length <= 0){
            setShowLoadLocksModal(false);
            return;
        }

        let apiURL = apiRoot + "/LoadLocks/AddLoadLocks";
        axios
        .post(
            apiURL,
            apiObj, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            setShowLoadLocksModal(false);
            props.forceRefreshFx();
        })
        .catch(error => {
            setErrorTitle("Update Error");
            setErrorBody("An error has occured.  Please review the console log for details.");
            console.log("RTS UpdateProject Error", error);
            setShowErrorModal(true);
        });        

    }


    function addLoadPins(args){
        let apiObj = [];
        args.forEach((item, idx) => {
            apiObj[idx] = {AppUser:user, Customer:sessionCustomer.customer, Load:item, Action:1};
        });

        if(apiObj.length <= 0){
            setShowLoadPinsModal(false);
            return;
        }        

        let apiURL = apiRoot + "/LoadPins/AddLoadPins";
        axios
        .post(
            apiURL,
            apiObj, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            setShowLoadPinsModal(false);
            props.forceRefreshFx();
        })
        .catch(error => {
            // setIsLoading(false);
            setErrorTitle("Update Error");
            setErrorBody("An error has occured.  Please review the console log for details.");
            console.log("RTS UpdateProject Error", error);
            setShowErrorModal(true);
        });        

    }



    return (
        <>
        <Dialog open={showErrorModal} onClose={()=>{setShowErrorModal(false);}}>
            <DialogTitle>{errorTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText>{errorBody}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowErrorModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog> 
        <Dialog fullWidth={true} maxWidth="md" open={showExportModal}>
            <DialogTitle>Export Data</DialogTitle>
            <DialogContent>
                <Box sx={{minHeight:"400px"}}>
                    <LoadListExport data={props.data} />
                </Box>            
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowExportModal(false);}}>Close</Button>
            </DialogActions>            
        </Dialog> 
        <Dialog fullWidth={true} maxWidth="md" open={showLoadLocksModal}>
            <DialogTitle>Lock Reels</DialogTitle>
            <DialogContent>
                <Box sx={{minHeight:"400px"}}>
                    <LoadListModeLockLoadsLookup loadList={props.data} addLoadLocksFx={addLoadLocks} setShowLoadLocksModalFx={setShowLoadLocksModal} />
                </Box>            
            </DialogContent>
        </Dialog> 
        <Dialog fullWidth={true} maxWidth="md" open={showLoadPinsModal}>
            <DialogTitle>Pin Reels</DialogTitle>
            <DialogContent>
                <Box sx={{minHeight:"400px"}}>
                    <LoadListModePinLoadsLookup loadList={props.data} addLoadPinsFx={addLoadPins} setShowLoadPinsModalFx={setShowLoadPinsModal} />
                </Box>            
            </DialogContent>
        </Dialog>         

        <Grid container spacing={2} id="mainGrid" sx={{mb:2, mt:0}}>
            <Grid item xs={4}>
                <Box sx={{mx:{xs:1, sm:2}, textAlign:'left'}}>
                    <Typography variant="h6" sx={{mr:2, fontSize:{xs:'.80em', md:'1em'}}}>{props.reelCount + ' Reels'}</Typography>
                </Box>
            </Grid>
            <Grid item xs={4} sx={{textAlign:'center',whiteSpace:{xs:'pre-line', sm:'nowrap'}}}>
                {props.mode===0
                ?
                <Button 
                    variant="outlined" 
                    startIcon={<FormatListBulletedOutlinedIcon />} 
                    disabled
                    sx={{mr:{xs:0, sm:2}}} 
                >
                    List
                </Button>
                :
                <Button 
                    variant="outlined" 
                    startIcon={<FormatListBulletedOutlinedIcon />} 
                    onClick={showList} 
                    sx={{mr:{xs:0, sm:2}}} 
                >
                    List
                </Button>
                }
                {props.mode===1
                ?
                <Button 
                    variant="outlined" 
                    startIcon={<MapOutlinedIcon />} 
                    disabled
                    sx={{mt:{xs:.5, sm:0}}}
                    >
                    Map
                </Button>
                :
                <Button 
                    variant="outlined" 
                    startIcon={<MapOutlinedIcon />} 
                    onClick={showMap}
                    sx={{mt:{xs:.5, sm:0}}}
                    >
                    Map
                </Button>
                }
            </Grid>
            <Grid item xs={4} sx={{whiteSpace:{xs:'pre-line', sm:'nowrap'}}}>
                <Box sx={{display:'flex', justifyContent:'right'}}>
                    {showLoadLocksIcon
                    ?
                    <Box sx={{mx:{xs:1, sm:2}, textAlign:'center'}}>
                        <Link onClick={clickLock} sx={{textDecoration:'none', cursor:'pointer'}}>
                            <LockIcon />
                            <Typography sx={{fontSize:'.5em', mt:-.75, pt:-.75}} >Lock</Typography>
                        </Link>
                    </Box>
                    :
                    ""
                    }
                    {showLoadPinsIcon
                    ?
                    <Box sx={{textAlign:'center'}}>
                        <Link onClick={clickPin} sx={{textDecoration:'none', cursor:'pointer'}}>
                            <PushPinIcon />
                            <Typography sx={{fontSize:'.5em', mt:-.75, pt:-.75}} >Pin</Typography>
                        </Link>
                    </Box>
                    :
                    ""
                    }
                    <Box sx={{textAlign:'center', mx:{xs:1, sm:2}}}>
                        <Link onClick={clickDownload} sx={{textDecoration:'none', cursor:'pointer'}}>
                            <FileDownloadIcon />
                            <Typography sx={{fontSize:'.5em', mt:-1, pt:-1}} >Download</Typography>
                        </Link>
                    </Box>
                </Box>
            </Grid>
        </Grid>
        </>
    );
}

